import React, { useState } from "react";
import UIInput from "./UIInput";

const OTHER_VALUE = "OTHER_VALUE";

const getIsOtherActive = (isOther, value, options) => {
    if (isOther && value && options.every(option => option.value !== value)) {
        return true;
    }
    return false;
};

const UISelect = ({
    name,
    value,
    defaultOptionTitle,
    options,
    required,
    labelClassName,
    label,
    error,
    errorName,
    onChange,
    isOptionsDisabled,
    color,
    isOther,
    $locale,
    props,
}) => {
    const [ isOtherActive, setIsOtherActive ] = useState(() => getIsOtherActive(isOther, value, options));

    const onChangeValue = (value) => {
        if (isOther && value === OTHER_VALUE) {
            setIsOtherActive(true);
            onChange("");
        } else {
            onChange(value);
            setIsOtherActive(false);
        }
    }

    return (
        <div className="ui-input-component ui-select">
            {!!label && (
                <label
                    htmlFor={name}
                    className={labelClassName}
                >
                    {label}
                </label>
            )}
            {error && errorName && 
                <label className="input-error">{errorName}</label>
            }
            {error && typeof error !== 'boolean' &&
                <label className="input-error">{error}</label>
            }
            <div className={`ui-select-container ${error ? 'input-error' : ''}`}>
                <select
                    {...props}
                    name={name}
                    value={isOtherActive ? OTHER_VALUE : value}
                    onChange={(e) => onChangeValue(e.target.value)}
                    required={required}
                    disabled={isOptionsDisabled}
                    style={{
                        color: color ? `#${color}` : '',
                    }}
                >
                    <option value="">
                        {defaultOptionTitle}
                    </option>
                    {options.map(({value, label}) => (
                        <option
                            key={value}
                            value={value}
                        >
                            {label}
                        </option>
                    ))}
                    {isOther && (
                        <option
                            key={OTHER_VALUE}
                            value={OTHER_VALUE}
                        >
                            {$locale.get('input.select.other')}
                        </option>
                    )}
                </select>
                {!isOptionsDisabled && (
                    <svg className="select-button" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 16 16" fill="none">
                        <path d="M7.1343 9.83325C7.5192 10.4999 8.48145 10.4999 8.86635 9.83325L10.0211 7.83325C10.406 7.16659 9.92483 6.33325 9.15503 6.33325H6.84563C6.07583 6.33325 5.5947 7.16658 5.9796 7.83325L7.1343 9.83325Z" fill="white"/>
                    </svg>
                )}
            </div>

            {isOtherActive && (
                <div className="ui-input-component ui-select-other">
                    <UIInput
                        name={OTHER_VALUE}
                        type={"text"}
                        value={value || ''}
                        onChange={onChange}
                        props={props}
                        placeholder={$locale.get('input.select.other.placeholder')}
                        disabled={isOptionsDisabled}
                    />
                </div>
            )}
        </div>
    );
};

export default UISelect;
